import React from 'react';
import './index.less';
import Ticon from '../Icon';

export default class CheckBox extends React.Component {
  state = {}

  constructor(props) {
    super(props);
  }

  handleChange = () => {
    if(this.props.templateItem && this.props.templateItem.ReadOnly === true){
      return;
    }
    this.props.onChange && this.props.onChange(!this.props.value);
  }

  render() {
    const {value, className='', children } = this.props;
    return (
      <div onClick={this.handleChange} className={`${className} checkBox`}>
        <Ticon type={`${value ? 'yixuan' : 'fuxuankuang'}`} className={`checkbox-icon ${value ? 'yixuan' : 'fuxuankuang'}`} />
        {children}
      </div>
    )
  }

}